
import { Vue, Component, Watch } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import Tinymce from '@/components/Tinymce/index.vue'
import Detail from './detail/index.vue'
import { UserModule } from '@/store/modules/user'
import setting from '@/settings'
import dayjs from 'dayjs'
import { getProtocolInfo, updateProtocolInfo, getProtocolHistory } from '@/api/systemset'
import { fileUploadPost } from '@/api/help'
@Component({
  name: 'protocol-config',
  components: {
    SimpleTable,
    Tinymce,
    Detail
  }
})
export default class ProtocolConfig extends Vue {
  // eslint-disable-next-line no-undef
  [x: string]: any
  private activeName = 'service'
  private setting = setting

  private dayjs = dayjs

  get userId () {
    return UserModule.id
  }

  private rules = {
    agreementVersionEdit: [
      { required: true, message: '请输入协议版本', trigger: 'blur' }
    ],
    contentEdit: [
      { required: true, message: '请输入协议内容', trigger: 'blur' }
    ]
  }

  private loading = !1

  private ifEdit = !1

  private ifSaveFinished = !0

  private dialogVisible = !1

  private dialogSubVisible = !1

  private form: any = {
    id: '', // 协议id
    agreementType: '', // 1-服务协议 2-隐私协议
    agreementVersion: '',
    agreementVersionEdit: '',
    content: '',
    contentEdit: ''
  }

  private dialogLoading = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'agreementVersion',
    label: '协议版本'
  },
  {
    prop: 'gmtCreate',
    label: '发布时间'
  }]

  private pagination = {
    currentPage: 1,
    pageSize: 10
  }

  private detailData: any = {}

  @Watch('activeName', { immediate: !0, deep: !0 })
  private activeNameChange () {
    this.initData()
  }

  private async initData () {
    this.ifEdit = !1
    Object.keys(this.form).map((key: any) => {
      this.form[key] = ''
    })
    this.form.agreementType = this.activeName === 'service' ? 1 : 2
    this.loading = !0
    await getProtocolInfo({
      agreementType: this.form.agreementType,
      status: 1 // 0-未启用 1-已启用
    }).then(async (res: any) => {
      if (res.code === 10000 && res.object) {
        Object.keys(res.object).map((key: any) => {
          this.form[key] = res.object[key]
        })
        // 替换第一个p标签
        this.form.content = this.form.content.replace('<p>', '')
        this.form.content = this.form.content.replace('</p>', '')
      }
      this.loading = !1
    }).catch(err => {
      this.loading = !1
      this.$message.error(err)
    })
  }

  private onEdit () {
    this.form.agreementVersionEdit = this.form.agreementVersion
    this.form.contentEdit = this.form.content
    this.ifEdit = !0
  }

  private onClose () {
    this.ifEdit = !1
  }

  private async imagesUploadHandler (blobInfo: any, succFun: any, failFun: any) {
    var formData: any = new FormData()
    formData.append('parentFolder', 'lb/protocolDetail')
    formData.append('file', blobInfo.blob(), blobInfo.filename())
    await fileUploadPost(formData).then((res: any) => {
      if (res.success) {
        const path = setting.ossIp + '/' + res.fileInfos[0].savePath
        succFun(path)
      } else {
        failFun()
      }
    })
  }

  private async onSave () {
    (this.$refs.form as any).validate(async (valid: any) => {
      if (this.form.contentEdit.replace(/<[^>]*>|/g, '').trim().length < 1) {
        this.$message.error('请输入协议内容')
        return
      }
      if (valid) {
        this.ifSaveFinished = !1
        // 去除Tinymce富文本所编辑内容的头部信息，避免小程序渲染时出错
        this.form.contentEdit = this.form.contentEdit.replace('<!DOCTYPE html>', '')
        this.form.contentEdit = this.form.contentEdit.replace('\n', '')
        this.form.contentEdit = this.form.contentEdit.replace('<html>', '')
        this.form.contentEdit = this.form.contentEdit.replace('\n', '')
        this.form.contentEdit = this.form.contentEdit.replace('<head>', '')
        this.form.contentEdit = this.form.contentEdit.replace('\n', '')
        this.form.contentEdit = this.form.contentEdit.replace('</head>', '')
        this.form.contentEdit = this.form.contentEdit.replace('\n', '')
        this.form.contentEdit = this.form.contentEdit.replace('<body>', '')
        this.form.contentEdit = this.form.contentEdit.replace('\n', '')
        this.form.contentEdit = this.form.contentEdit.replace('</body>', '')
        this.form.contentEdit = this.form.contentEdit.replace('\n', '')
        this.form.contentEdit = this.form.contentEdit.replace('</html>', '')
        this.form.contentEdit = this.form.contentEdit.replace('\n', '')
        await updateProtocolInfo({
          id: this.form.id,
          creatorId: this.userId,
          agreementType: this.form.agreementType,
          agreementVersion: this.form.agreementVersionEdit,
          content: this.form.contentEdit,
          status: 1 // 0-未启用 1-已启用
        }).then((res: any) => {
          if (res.code === 10000) {
            this.form.agreementVersion = this.form.agreementVersionEdit
            this.form.content = this.form.contentEdit
            // 替换第一个p标签
            this.form.content = this.form.content.replace('<p>', '')
            this.form.content = this.form.content.replace('</p>', '')
            this.ifEdit = !1
            this.ifSaveFinished = !0
            this.$message.success(res.message)
          } else {
            this.ifSaveFinished = !0
            this.$message.error(res.message)
          }
        }).catch((err: any) => {
          this.ifSaveFinished = !0
          console.log('err', err)
        })
      }
    })
  }

  private onVersion () {
    this.dialogVisible = !0
  }

  private open () {
    this.initTable({
      currentPage: 1,
      pageSize: 10
    })
  }

  private async initTable (pagination: any) {
    this.dialogLoading = !0
    this.tableData.list = []
    await getProtocolHistory({
      agreementType: this.form.agreementType,
      status: 0, // 0-未启用 1-已启用
      ...pagination || this.pagination
    }).then(async (res: any) => {
      this.tableData.list = res.object.list.map((v: any) => {
        v.gmtCreate = v.gmtCreate && v.gmtCreate !== -1 ? dayjs(v.gmtCreate).format('YYYY-MM-DD HH:mm') : ''
        // 替换第一个p标签
        v.content = v.content.replace('<p>', '')
        v.content = v.content.replace('</p>', '')
        return v
      })
      this.tableData.totalCount = res.object.total
      this.dialogLoading = !1
    }).catch((err: any) => {
      this.dialogLoading = !1
      console.log('err', err)
    })
  }

  private async showDetail (row: any) {
    console.log(row)
    this.detailData = row
    this.dialogSubVisible = !0
  }

  private closeDialog () {
    // do something
  }
}
